( ( $ ) => {
	if ( $( '.wp-block-table.is-style-stripes-stack' ).length > 0 ) {
		$( '.wp-block-table.is-style-stripes-stack' ).each( function(){
			const table = $( this ).find( 'table' );
			const headings = Array.from( table.find( 'thead th' ) ).map( x => x.innerHTML );
			const firstCol = Array.from( table.find( 'tbody tr td:first-child' ) ).map( x => x.innerHTML );
			const nColumns = table.find( 'tbody tr:first-child td' ).length;
			const nRows = table.find( 'tbody tr' ).length;
			let newTable = '';
			let i, j;
			for ( i = 1; i < nColumns; i++ ) {
				let col = Array.from( table.find( 'tbody tr td:nth-child('+ (i+1) +')' ) ).map( x => x.innerHTML );
				newTable += '<div class="tblock">';
				newTable += '<div class="thead">' + headings[i] + '</div>';
				for ( j = 0; j < nRows; j++ ) {
					newTable += '<div class="trow">';
					newTable += '<div class="tcell tcell-1">' + firstCol[j] + '</div>';
					newTable += '<div class="tcell">' + col[j] + '</div>';
					newTable += '</div>';
				}
				newTable += '</div>';
			}
			$( this ).prepend( newTable );
		});
	}
})(jQuery)
